import { createFileRoute } from '@tanstack/react-router';
import { StaticPage } from '../components/static/StaticPage';
import { staticHead } from '../lib/seo';
import { getStaticPage } from '../lib/static-content';

export const Route = createFileRoute('/about')({
  head: () => {
    const p = getStaticPage('about');
    return staticHead({ pathname: '/about', title: p.title, description: p.metaDescription });
  },
  component: () => <StaticPage slug="about" />,
});
